import { useCallback, useEffect, useRef, useState } from "react";
import Lenis from "lenis";
import { Toaster } from "./components/ui/sonner";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Chales from "./components/Chales";
import Decoracao from "./components/Decoracao";
import Experiencia from "./components/Experiencia";
import Booking from "./components/Booking";
import Faq from "./components/Faq";
import Footer from "./components/Footer";

export default function App() {
    const lenisRef = useRef(null);
    const [chale, setChale] = useState("lua-cheia");
    const [decoracao, setDecoracao] = useState("nenhuma");

    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.08, smoothWheel: true });
        lenisRef.current = lenis;
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);

    const scrollTo = useCallback((target) => {
        if (lenisRef.current) {
            lenisRef.current.scrollTo(target, { offset: -64, duration: 1.4 });
        } else {
            document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
        }
    }, []);

    return (
        <div className="min-h-screen bg-stone-50 text-stone-900">
            <Navbar onNavigate={scrollTo} />
            <Hero onReserve={() => scrollTo("#reserva")} />
            <Marquee />
            <Chales selected={chale} onSelect={(id) => { setChale(id); scrollTo("#reserva"); }} />
            <Decoracao selected={decoracao} onSelect={(id) => { setDecoracao(id); if (id !== "nenhuma") scrollTo("#reserva"); }} />
            <Experiencia />
            <Booking chale={chale} setChale={setChale} decoracao={decoracao} setDecoracao={setDecoracao} />
            <Faq />
            <Footer />
            <Toaster position="top-center" richColors />
        </div>
    );
}
